cobalt-progress-indicator {
  display: block;
}
